import parsePhoneNumber, {
    PhoneNumber
} from 'libphonenumber-js';

export const CONTACT_PHONE_NUMBER: PhoneNumber = parsePhoneNumber("+14164003242")!;
export const CONTACT_EMAIL: string = "support@tenerapro.com";
export const CONTACT_WEBSITE: string = "www.tenerapro.com";